// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const BASE_API = 'https://api.autoideas.in';

const apiEndPoints = {
  v1: 'https://bvlrmkycz1.execute-api.ap-south-1.amazonaws.com/dev/',
  v2: 'https://8izzlasq95.execute-api.ap-south-1.amazonaws.com/dev/',
  v3: 'https://4dxgwe9ir0.execute-api.ap-south-1.amazonaws.com/dev/',
  v4: 'https://xh9xj1dfmi.execute-api.ap-south-1.amazonaws.com/dev/',
  v5: 'https://lix6b9is86.execute-api.ap-south-1.amazonaws.com/dev/',
  v6: 'https://cgcudmoy13.execute-api.ap-south-1.amazonaws.com/dev/',
  wsapi:
    'https://74qhowf070.execute-api.ap-south-1.amazonaws.com/dev/@connections',
};

export const environment = {
  production: true,
  authCheck_api: 'https://carcastle.autozaki.com/api/',
  client_frontend_url: 'https://develop.d2fkztdavmlwxw.amplifyapp.com/',
  forntend_url: 'https://develop-2026.d11c46pn41tu67.amplifyapp.com/',
  imgBaseUrl:
    'https://pub-63c973c88111442dbc6a2ac741c81bb7.r2.dev/storage/gallery/images/',
  auctionBaseUrl:
    'https://pub-63c973c88111442dbc6a2ac741c81bb7.r2.dev/storage/auction/images/',
  api: apiEndPoints.v1,
  newInventoryApi: apiEndPoints.v2,
  payment_api: apiEndPoints.v2,
  recycleApi: apiEndPoints.v2,
  pdiAPI: apiEndPoints.v3,
  v4: apiEndPoints.v4,
  v5: apiEndPoints.v5,
  v6: apiEndPoints.v6,
  WS_API: apiEndPoints.wsapi,

  vamId: 'evaluator1@gmail.com',
  vamPassword: 'Naruto@123',
};

// ng build --base-href="http://128.199.25.224/siarty/auction/" --deploy-url="http://128.199.25.224/siarty/auction/" --prod
